import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import ModulesTable from '../ModulesTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import ViewUtils from "./../../ViewUtils";
import { ViewContainer } from "./../../View.jsx";
import AlertItem from "../../widgets/AlertItem";


const utils = new ViewUtils();

const headCells = [
    { id: 'ModuleCode', numeric: false, disablePadding: true, label: 'QCTO Module ID' },
    { id: 'ModuleTitle', numeric: false, disablePadding: true, label: 'QCTO Module Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'ModuleType', numeric: false, disablePadding: true, label: 'Module Type' }
];

const toolbarRef = React.createRef();

class ProviderQualificationModuleSearch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedModule: null,
            selectedModuleCode: null,
            selectedModuleTitle: null,
            keyUpSwitch: false,
            message: "",
            messageStyle: "",
            searchParameters: [
                { Name: "ProviderQualificationID", Value: this.props.location.state.ProviderQualificationID },
                { Name: "ProviderID", Value: this.props.location.state.ProviderID }
            ]

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'submodules', label: '', tooltip: 'View sub modules linked to the providers qualification module', icon: 'ViewIcon', disabled: utils.isNull(this.state.selectedModule) }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/ProviderQualificationsSearch',
                state: {
                    selection: this.props.location.state.ProviderID,
                    providerName: this.props.location.state.providerName,
                    providerSDLNumber: this.props.location.state.providerSDLNumber
                }
            });
        } else if ("submodules" === buttonId) {
            this.props.history.push({
                pathname: '/ProviderQualificationModuleSMSearch',
                state: {
                    ProviderID: this.props.location.state.ProviderID,
                    providerName: this.props.location.state.providerName,
                    providerSDLNumber: this.props.location.state.providerSDLNumber,
                    ProviderQualificationID: this.props.location.state.ProviderQualificationID,
                    QualificationCode: this.props.location.state.QualificationCode,
                    QualificationTitle: this.props.location.state.QualificationTitle,
                    ModuleID: this.state.selectedModule,
                    ModuleCode: this.state.selectedModuleCode,
                    ModuleTitle: this.state.selectedModuleTitle
                }
            });
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({
                selectedModule: selection[0].Id,
                selectedModuleCode: selection[0].ModuleCode,
                selectedModuleTitle: selection[0].ModuleTitle,
                message: "",
                messageStyle: ""
            });
        } else {
            this.setState({
                selectedModule: null,
                selectedModuleCode: null,
                selectedModuleTitle: null,
                message: "",
                messageStyle: ""
            });
        }

        toolbarRef.current.setButtonDisabled("submodules", selection === null || selection.length === 0);
    }

    render() {
        return (
            <ViewContainer>
                <p className="breadcrumbs">
                    {"Provider > Qualification Modules " + (this.props.location.state.providerName !== null ? "> " + this.props.location.state.providerName + (this.props.location.state.providerSDLNumber !== null ? " - " + this.props.location.state.providerSDLNumber : "") : "")
                        + (this.props.location.state.QualificationTitle !== null ? " > " + this.props.location.state.QualificationTitle + (this.props.location.state.QualificationCode !== null ? " - " + this.props.location.state.QualificationCode : "") : "")}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <div className="searchResults">
                    <EnhancedToolbar highlight={false}
                        ref={toolbarRef}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />
                    <ModulesTable headCells={headCells} onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        dataUrl="api/sims/providerqualification/GetProviderQualificationModuleSearch"
                        height={"50vh"}
                        searchParameters={this.state.searchParameters} paged={false} />
                </div>

            </ViewContainer>

        );
    }
}

export default withRouter(
    connect()(ProviderQualificationModuleSearch)
);
